import React, { useEffect } from "react";
import RootStore from "./stores/RootStore";
import MainArea from "./components/MainArea";
import SearchAppBar from "./components/AppBar";
import stdBottomBar from "./components/BottomBar";

const Widget = ({
  widgetsConfig,
  AppBar,
  BottomBar,
  requestsConfig,
  theme,
  nls,
  mapConfig,
  children,
}) => {
  RootStore.config = mapConfig;
  if (!AppBar) {
    AppBar = SearchAppBar;
  }
  if (!BottomBar) {
    BottomBar = stdBottomBar;
  }
  // const [isInitialising, setIsInitialising] = useState(true);

  useEffect(() => {
    RootStore.uiStore.initialize({
      widgetConfigs: widgetsConfig,
      requestsConfig,
    });
    //   // RootStore.initConfig().then(() => {
    //   initApp();
    //   // });
  }, [widgetsConfig, requestsConfig]);

  // const initApp = () => {
  //   I18N.loadLocale(RootStore.config.locale || "de");
  //   setIsInitialising(false);
  // };

  // if (isInitialising) {
  //   return <div />;
  // }
  return (
    <div id="app-container">
      <AppBar />
      <MainArea />
      {children}
      <BottomBar />
    </div>
  );
  // return <div></div>;
};

export default Widget;
